import { target } from "msem-lib/es/services/target";
import * as React from "react";
import Button from "msem-ui/es/button";
import css from "./widget-error.module.css";
import configuration from "../../services/config";
import { formatDate } from "../../services/date";

const publicApi = configuration().publicApi;
const env = target();

type Props = {
  children: React.ReactNode;
  context?: any;
  widget?: string;
  stay?: any;
};

type State = {
  error: Error | null;
};

export default class ErrorBoundary extends React.Component<Props> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  async componentDidCatch() {
    if (env === "development") return;
    const { error } = this.state;
    const widget = this.props.widget || "";
    const url = window.location.href;
    const userAgent = window.navigator.userAgent;
    const stay = this.props.stay || null;
    const stayFrom = stay?.dates?.from ? formatDate(stay.dates.from) : null;
    const stayTo = stay?.dates?.to ? formatDate(stay.dates.to) : null;
    const name = error?.name;
    const message = error?.message;
    const stack = error?.stack || "";
    const context = this.props.context || {};

    const errorInfo = {
      widget,
      url,
      userAgent,
      name,
      message,
      stack,
      context,
      stayFrom,
      stayTo,
    };
    try {
      await fetch(`${publicApi}/widget-error`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(errorInfo),
      });
    } catch (e) {
      // Silent catch
    }
  }

  tryAgain = () => {
    this.setState({ error: null });
  };

  render() {
    const { error } = this.state;
    return (
      <>
        {error !== null && (
          <div className={css.error}>
            <div className={css.alert}>
              <div className={css.alertTitle}>Une erreur s'est produite !</div>
              <div className={css.alertSubtitle}>
                C'est embarrassant...
                <span role="img" aria-label="">
                  😔
                </span>
              </div>
              <Button className={css.button} onClick={this.tryAgain} size="S">
                Réessayer
              </Button>
            </div>
            <div className={css.report}>
              <div className={css.title}>
                <span className={css.prefix}>Erreur : </span>
                <span className={css.message}>{error.message}</span>
              </div>
            </div>
          </div>
        )}
        {error === null && this.props.children}
      </>
    );
  }
}
